const devConfig = {
  api: "https://juicysuite-platform.juicyapp.dev/member/api",
};

export default devConfig;
